import { render, staticRenderFns } from "./PrelimsRoundScoreCrews.vue?vue&type=template&id=6a473886&scoped=true"
import script from "./PrelimsRoundScoreCrews.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrelimsRoundScoreCrews.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PrelimsRoundScoreCrews.vue?vue&type=style&index=0&id=6a473886&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a473886",
  null
  
)

export default component.exports